import React from "react";
import Layout from "../Common/Layout";
import { Link } from "react-router-dom";

const PastControlReport = () => {
  const tableData = [
    {
      slno: 1,
      lastPestControlDate: "2025-01-12",
      companyName: "AgroBuild Pvt. Ltd",
      slip: "pest-slip-001.pdf",
    },
    {
      slno: 2,
      lastPestControlDate: "2025-01-20",
      companyName: "GreenWarehouse Corp",
      slip: "pest-report-jan20.pdf",
    },
    {
      slno: 3,
      lastPestControlDate: "2025-02-05",
      companyName: "FreshGrains Ltd",
      slip: "pest-protection-005.pdf",
    },
    {
      slno: 4,
      lastPestControlDate: "2025-02-10",
      companyName: "Harvest India Pvt Ltd",
      slip: "fumigation-slip-feb10.pdf",
    },
    {
      slno: 5,
      lastPestControlDate: "2025-02-15",
      companyName: "SafeStorage Enterprises",
      slip: "fumigation-report-215.pdf",
    },
  ];

  return (
    <Layout>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            
            <h4 className="mt-4 mb-3 fw-semibold text-primary">
              Pest Control Records
            </h4>
            <div className="text-center mb-2"><Link style={{ color: "white"}} to="/dashboard" className='btn btn-primary'>Dashboard</Link></div>
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped text-center">
                    <thead className="table-dark">
                      <tr>
                        <th>Sl No</th>
                        <th>Last Pest Control Date</th>
                        <th>Company Name</th>
                        <th>Uploaded Pest Control Slip</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tableData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.slno}</td>
                          <td>{item.lastPestControlDate}</td>
                          <td>{item.companyName}</td>
                          <td>
                            <a href="#" className="btn btn-sm btn-primary">
                              {item.slip}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PastControlReport;
